export const buildInfo = {"timestamp":"2026-11-04T14:36:46.396Z"};